import React from 'react'

function SVG2() {
    return (
        <svg style={{width: 20, height: 20, cursor: 'pointer'}} width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.87482 9.99015L0 18.865L1.41421 20.2792L10.289 11.4044L19.1651 20.2804L20.5793 18.8662L11.7032 9.99015L20.2792 1.41421L18.865 0L10.289 8.57593L1.71434 0.00124085L0.300126 1.41545L8.87482 9.99015Z" fill="#2F2A25" fill-opacity="0.6" />
        </svg>

    )
}

export default SVG2
